// extracted by mini-css-extract-plugin
export default {"root":"Header-module_root__rzAoa","logo":"Header-module_logo__I4JFr","nav":"Header-module_nav__ogRZs"};